import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Box,
  Card,
  CardContent,
  Typography,
  CircularProgress,
} from "@mui/material";
import TableCompo from "../CommonTable/TableCompo";
import { getGiftHistoryRequest } from "../../redux/Gifts/giftSlice";
import { useAppTheme } from "../../theme/useAppTheme";

const GiftHistoryScreen = () => {
  const dispatch = useDispatch();
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);

  const {
    data: giftHistory,
    loading,
    error,
  } = useSelector((state) => state.gift || {});

  useEffect(() => {
    dispatch(getGiftHistoryRequest());
  }, [dispatch]);

  const themeColors = useAppTheme();

  const columns = [
    { field: "metal", headerName: "Metal", flex: 1 },
    { field: "date", headerName: "Date & Time", flex: 1.5 },
    { field: "giftTo", headerName: "gift To", flex: 1 },
    { field: "occasion", headerName: "Gift Message", flex: 1 },
    { field: "status", headerName: "Gift Status", flex: 1 },
  ];

  const tableData = Array.isArray(giftHistory)
    ? giftHistory.map((item, index) => ({
        id: index + 1,
        metal: `${item?.bullion?.metalName || "N/A"} ${item?.bullion?.karat || ""}k-${item?.bullion?.purity || ""}`,
        date: item?.createdAt
          ? new Date(item.createdAt).toLocaleString("en-IN", {
              day: "2-digit",
              month: "short",
              year: "numeric",
              hour: "2-digit",
              minute: "2-digit",
            })
          : "N/A",
        giftTo: item?.giftTo || "N/A",
        occasion: item?.occasion || "N/A",
        status: item?.isAccepted ? "ACCEPTED" : "PENDING",
      }))
    : [];
      const handleTableChange = (type, payload) => {
        if (type === "changePage") {
        setPage(payload.page);
        }
        if (type === "changeRowsPerPage") {
        setLimit(payload.rowsPerPage);
        setPage(0);
        }
      };

      const paginatedData = tableData.slice(
        page * limit,
        page * limit + limit
      );

  return (
    <Box
      sx={{
        width: "100%",
        maxWidth: 1300,
        mx: "auto",
        mt: 8,
        px: { xs: 1.5, sm: 2 },
        color: themeColors.scaffoldText,
      }}
    >
          <Typography
            variant="h5"
            sx={{
              mb: 2,
              fontWeight: 700,
              color: themeColors.primary,
              fontFamily: "Aeonik",
            }}
          >
            Gift History
          </Typography>

          {loading ? (
            <Box sx={{ textAlign: "center", mt: 10 }}>
              <CircularProgress color="primary" />
              <Typography variant="body2" mt={2}>
                Loading gift history...
              </Typography>
            </Box>
          ) : error ? (
            <Typography color="error" textAlign="center" mt={5}>
              {error}
            </Typography>
          ) : (
            <Box
              sx={{
                height: "70vh",
                width: "100%",
                minWidth: 0,
                overflow: "auto",
              }}
            >
              <TableCompo
                title="Sell History"
                columns={columns}
                data={paginatedData}
                page={page}
                limit={limit}
                totalCount={tableData.length}
                onTableChange={handleTableChange}
                loading={loading}
              />
            </Box>
          )}
    </Box>
  );
};

export default GiftHistoryScreen;
